module.exports = __webpack_public_path__ + "static/img/plan-task_04.91bcf276.png";